import { HttpContext } from '@angular/common/http';

import { type RequestOptions } from '../types';

import { ALLOW_REFRESH, REQUIRES_AUTH, SKIP_BASE_URL, SKIP_API_ENVELOPE_UNWRAP } from '../tokens';

export function buildHttpContext(options: RequestOptions = {}): HttpContext {
  const context = new HttpContext();

  if (options.skipAuth) {
    context.set(REQUIRES_AUTH, false);
  }

  if (options.skipAuthRefresh) {
    context.set(ALLOW_REFRESH, false);
  }

  if (options.skipBaseUrl) {
    context.set(SKIP_BASE_URL, true);
  }

  if (options.skipApiEnvelopeUnwrap) {
    context.set(SKIP_API_ENVELOPE_UNWRAP, true);
  }

  return context;
}
